export default {
      id: "easter-egg-usage",
      viewBox: "0 0 11 15",
      url: __webpack_public_path__ + "img/icons.svg#easter-egg",
      toString: function () {
        return this.url;
      }
    }